import script from "./saveAs.vue?vue&type=script&lang=ts&setup=true"
export * from "./saveAs.vue?vue&type=script&lang=ts&setup=true"

import "./saveAs.vue?vue&type=style&index=0&id=6a2cb39b&lang=scss&scoped=true"
import "./saveAs.vue?vue&type=style&index=1&id=6a2cb39b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a2cb39b"]])

export default __exports__